import React, { useState } from "react";
import { Button, Upload } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";

export default function FileAttachmentComponent({ onSend }) {
  const [fileList, setFileList] = useState([]);

  const handleChange = ({ file, fileList }) => {
    if (file.status === "done") {
      onSend(file.originFileObj); 
    }
    setFileList(fileList);
  };

  const customRequest = ({ onSuccess, onError }) => {
    setTimeout(() => {
      onSuccess();
    }, 1000);
  };

  return (
    <Upload
      customRequest={customRequest}
      onChange={handleChange}
      fileList={fileList}
      showUploadList={false}
      accept="image/*, .pdf, .doc, .docx, .txt, .mp3"
    >
      <Button icon={<PaperClipOutlined />} type="default"></Button>
    </Upload>
  );
}
